import { useRef } from 'react';
import { Form } from 'react-bootstrap';
import '../style.scss';

interface GridItemProps {
  text: string;
  readonly: boolean;
  id: string;
  name: string;
  errors: any;
  nutrition_cd: number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const NutritionInputItem = ({ text, readonly, id, nutrition_cd, name, onChange, errors }: GridItemProps) => {
  const inputRef = useRef<any>(null);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Set parent background color
    const parent = inputRef.current?.parentElement?.parentElement;
    if (parent) {
      parent.style.background = '#f8cecc';
    }
    onChange(e);
  };

  return (
    <Form.Group controlId={id}>
      <Form.Control
        type="number"
        min={0}
        name={name}
        step={0.1}
        readOnly={readonly}
        defaultValue={text}
        onChange={handleChange}
        ref={inputRef}
        isInvalid={!!errors[nutrition_cd]}
      />
      {errors[nutrition_cd] && (
        <Form.Control.Feedback type="invalid" className="">
          {errors[nutrition_cd].nutrition_amount}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default NutritionInputItem;
